import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useCreateFlow = () => {
  const dispatch = useDispatch();
  const orgId = useSelector(state => state.session.user.primaryOrganization.organization.ID);

  const {
    isLoading, isSuccess, isError, data, mutate, mutateAsync,
  } = useMutation(
    `flow-creation-${orgId}`,
    (payload) => axiosInstance.post(flow(orgId).create(), payload),
    {
      onSuccess: () => {
        dispatch(showAlert({ message: 'Flow has been created.', type: 'success' }));
      },
      onError: (error) => dispatch(showAlert({ message: error.response.data.message, type: 'error' })),
    },
  );

  return {
    isLoading, isError, isSuccess, data, mutate, mutateAsync,
  };
};

